"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var defaultProps = {
  animationDuration: 1500,
  animate: true
};

var LoadingPlaceholder =
/** @class */
function (_super) {
  __extends(LoadingPlaceholder, _super);

  function LoadingPlaceholder() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.animateEl = null;
    _this.animationStart = NaN;

    _this.ref = function (el) {
      _this.animateEl = el;

      if (_this.animateEl && _this.props.animate && typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(_this.animationLoop);
      }
    };

    _this.animationLoop = function (timestamp) {
      if (!_this.animateEl || !_this.props.animate) {
        return;
      }

      if (!_this.animationStart) {
        _this.animationStart = timestamp;
      }

      var props = _this.props;
      var progress = (timestamp - _this.animationStart) % props.animationDuration / props.animationDuration; // 0 - 1

      var x = (progress - 0.5) * 200; // -100 - 100

      _this.animateEl.style.transform = "translateX(" + x + "%) rotateZ(10deg) scaleY(1.5)";
      requestAnimationFrame(_this.animationLoop);
    };

    return _this;
  }

  LoadingPlaceholder.prototype.render = function () {
    return React.createElement("div", {
      style: __assign({
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        background: '#f3f3f3',
        overflow: 'hidden',
        pointerEvents: 'none'
      }, this.props.style)
    }, React.createElement("div", {
      ref: this.ref,
      style: __assign({
        position: 'absolute',
        display: 'block',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        background: 'linear-gradient(90deg,rgba(255,255,255,0) 0,rgba(255,255,255,0.7) 50%,rgba(255,255,255,0) 100%)',
        backgroundSize: '50% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }, this.props.animationStyle)
    }));
  };

  LoadingPlaceholder.defaultProps = defaultProps;
  return LoadingPlaceholder;
}(React.Component);

exports.default = LoadingPlaceholder;